/** Tiny inline SVG polyline for a numeric series, with an optional normal band. */
import { cn } from '@/lib/cn';

export function Sparkline({
  values,
  width = 72,
  height = 20,
  band,
  className,
  stroke = 'var(--color-ink-2)',
}: {
  values: number[];
  width?: number;
  height?: number;
  band?: { low: number; high: number } | null;
  className?: string;
  stroke?: string;
}) {
  if (values.length < 2) return null;
  const all = band ? [...values, band.low, band.high] : values;
  const min = Math.min(...all);
  const max = Math.max(...all);
  const span = max - min || 1;
  const x = (i: number) => (i / (values.length - 1)) * (width - 2) + 1;
  const y = (v: number) => height - 1 - ((v - min) / span) * (height - 2);
  const points = values.map((v, i) => `${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={cn('shrink-0', className)} aria-hidden="true">
      {band && <rect x={0} y={y(band.high)} width={width} height={Math.max(1, y(band.low) - y(band.high))} fill="var(--color-nominal)" opacity={0.15} />}
      <polyline points={points} fill="none" stroke={stroke} strokeWidth={1.25} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(values.length - 1)} cy={y(values[values.length - 1])} r={1.75} fill={stroke} />
    </svg>
  );
}
